import { ChangeDetectionStrategy, Component, inject, linkedSignal, signal } from "@angular/core";

import { IButtonDirective, ISelectMenuImports, MODAL_DATA, ModalRef } from "@front/m19-ui";
import { OrganizationAccountGroups } from "@front/m19-models";
import { TranslocoDirective } from "@jsverse/transloco";
import { AccessLevel } from "@front/m19-api-client";

export interface SelectOrganizationModalData {
  allOrganizations: OrganizationAccountGroups[];
}

@Component({
  selector: "app-select-organization-modal",
  imports: [ISelectMenuImports, IButtonDirective, TranslocoDirective],
  templateUrl: "./select-organization-modal.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SelectOrganizationModalComponent {
  private readonly modalData = inject(MODAL_DATA) as SelectOrganizationModalData;
  readonly modalRef = inject(ModalRef);

  protected readonly organizations = signal(
    this.modalData.allOrganizations.filter(
      (org) => org.hasActiveSubscription() && org.accessLevel === AccessLevel.ADMIN,
    ),
  );

  protected readonly selectedOrganization = linkedSignal(() => this.organizations()[0]);

  selectOrganization() {
    this.modalRef.close(this.selectedOrganization());
  }
}
